<template>
  <div class="vanta-bg" ref="vantaContainer"></div>
  <div class="login-container">
    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor" class="snackbar">
      <v-icon class="snackbar-icon" dark>{{ snackbarIcon }}</v-icon>
      <span class="snackbar-text">{{ snackbarText }}</span>
    </v-snackbar>
    <div class="login-box">
      <LogoComponent :logo="project.tabName || project.name" />
      <div class="login-form" @keyup.enter="login">
        <label for="email">Correo institucional (sin @usach.cl)</label>
        <input v-model="email" type="text" id="email" placeholder="nombre.apellido" class="input-field"
          autocorrect="off" spellcheck="false" ref="emailInput" />

        <label for="password">Contraseña</label>
        <input v-model="password" type="password" id="password" placeholder="********" class="input-field" />

        <button @click="login" class="login-button">Iniciar Sesión</button>
        <button class="register-button" @click="register">Registrarse</button>
      </div>
    </div>
  </div>
</template>

<script>
import LogoComponent from "@/components/generic/LogoComponent.vue";
import api from "@/api.js";
import * as THREE from "three";
import FOG from "vanta/src/vanta.fog";

export default {
  name: "LoginComponent",
  components: {
    LogoComponent,
  },
  watch: {
    project(){
      this.setTabHeaders();
    }
  },
  data() {
    return {
      email: "",
      password: "",
      project: {},
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      snackbarIcon: "",
    };
  },
  methods: {
    async login() {
      const idProject = this.$route.params.projectId;
      try {
        // Realizar login normal
        let dynamic_email = this.email.replace('@usach.cl', '') + "@usach.cl";
        const response = await api.post(`/api/auth/signin`, {
          email: dynamic_email,
          password: this.password,
        });

        if (!response.data.token) {
          this.snackbarText = "Credenciales incorrectas";
          this.snackbarColor = "error";
          this.snackbarIcon = "mdi-alert-circle";
          this.snackbar = true;
          return;
        }

        const token = response.data.token;
        localStorage.setItem("token", token);
        localStorage.setItem("email", dynamic_email);

        // Obtener información del proyecto
        const projectResponse = await api.get(
          `/api/project/getProjectbyID/${idProject}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const project = projectResponse.data;
        this.$store.commit('setProject', project);
        localStorage.setItem('project', JSON.stringify(project));

        // Verificar si el usuario pertenece al proyecto
        const integrant = project.userMembers.find(
          (memberEmail) => memberEmail === this.email + "@usach.cl"
        );

        if (!integrant) {
          this.snackbarText = "No perteneces a este proyecto";
          this.snackbarColor = "error";
          this.snackbarIcon = "mdi-alert-circle";
          this.snackbar = true;
          return;
        }

        this.snackbarText = "Login exitoso";
        this.snackbarColor = "success";
        this.snackbarIcon = "mdi-check-circle";
        this.snackbar = true;

        // Redirigir al home del proyecto
        setTimeout(() => {
          // Destruir vanta.js
          if(this.vantaEffect){
            this.vantaEffect.destroy();
            this.vantaEffect = null;
          }
          this.$router.push({
            name: 'MeetingWareHome',
            params: { projectId: idProject },
          });
        }, 2000);
      } catch (error) {
        console.error(error);
        this.snackbarText = "Error al iniciar sesión";
        this.snackbarColor = "error";
        this.snackbarIcon = "mdi-alert-circle";
        this.snackbar = true;
      }
    },
    async getprojectInfo() {
      try {
        const response = await api.get(
          `/api/project/public-info/${this.$route.params.projectId}`
        );
        this.project = response.data;
        console.log("Project info:", this.project);

      } catch (e) {
        console.error(e);
      }
    },
    register(){
      const idProject = this.$route.params.projectId;
      // TODO: cambiar por MeetingWareRegister
      this.$router.push({
        name: 'Register',
        params: { projectId: idProject },
      });
    },
    setTabHeaders(){
      document.getElementById("favicon").href = this.project.iconUrl;
      document.title = this.project.tabName || this.project.name + ' - Login' || "Meeting Engine - Login";
    }
  },
  created(){
    this.getprojectInfo();
  },
  mounted() {
    if (this.$refs.vantaContainer) {
      this.vantaEffect = FOG({
        el: this.$refs.vantaContainer,
        THREE,
        mouseControls: false,
        touchControls: false,
        gyroControls: false,
        minHeight: 200.0,
        minWidth: 200.0,
        scale: 1.0,
        scaleMobile: 1.0,
        highlightColor: parseInt('0xffff', 16),
        midtoneColor: parseInt('8A4584', 16),
        lowlightColor: parseInt('0xd200ff', 16),
      });
      console.log("Vanta FOG initialized!");
    }

    this.$nextTick(() => {
      if (this.$refs.emailInput) {
        this.$refs.emailInput.focus();
      }
    });
    document.title = this.project.name || "Meeting Engine";
    document.getElementById("favicon").href = this.project.iconUrl;
  },
  beforeUnmount() {
    if (this.vantaEffect) {
      this.vantaEffect.destroy();
      this.vantaEffect = null;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.vantaEffect) {
      this.vantaEffect.destroy();
      this.vantaEffect = null;
    }
    next();
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  user-select: none;
  position: relative;
  background-color: transparent;
}

.snackbar {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  font-size: 16px;
}

.snackbar-icon {
  margin-right: 10px;
  font-size: 20px;
  color: white;
}

.snackbar-text {
  font-weight: bold;
  color: white;
}

.login-box {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-align: center;
  width: 350px;
  position: relative;
  z-index: 1;
  
}

.login-form {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

label {
  text-align: left;
  font-size: 14px;
  margin-bottom: 5px;
  color: #444;
}

.input-field {
  margin-bottom: 15px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
  width: 100%;
  background-color: #f9f9f9;
}

.login-button,
.register-button {
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;
  margin-top: 10px;
}

.login-button {
  background-color: #20c997;
  color: white;
}

.login-button:hover {
  background-color: #17a2b8;
}

.register-button {
  background-color: white;
  color: #17a2b8;
  border: 2px solid #17a2b8;
}

.register-button:hover {
  background-color: #17a2b8;
  color: white;
}
</style>
